import { render, staticRenderFns } from "./ed-lesson-nav.vue?vue&type=template&id=a8af6e82&scoped=true&"
import script from "./ed-lesson-nav.ts?vue&type=script&lang=js&"
export * from "./ed-lesson-nav.ts?vue&type=script&lang=js&"
import style0 from "./ed-lesson-nav.scss?vue&type=style&index=0&id=a8af6e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8af6e82",
  null
  
)

export default component.exports